// extracted by mini-css-extract-plugin
export default {"container":"copyable-text_container__Xtslz"};